export default "__VITE_ASSET__BkkVbiDm__"